export function isPortValid(t, port) {
    if (/^\d{2,5}$/.test(port)) {
      return ({
        valid: true
      });
    } else {
      return ({
        valid: false,
        help: t('scenes.mappingHandler.DDBConnection.messages.warning.portLegth')
    })}
}

export function isFieldValid(t, value) {
  if (!value || (value && !String(value).trim())) {
      return {
          valid: false,
          help: t("commons.alerts.requiredField.content")
      };
  }
  return ({
      valid: true
  });
}